import store from "../store";
export const getAllStore = (state) => {
    const keys = Object.keys(store.getState());
    const result = {};
    keys.forEach((key) => {
        result[key] = state[key];
    });
    return result;
};
